import { Component, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'form-select-field',
    template: `
         <div class="select" [ngClass]="{
             'placeholded':!getValue(),
             'ng-valid': field.valid,
             'ng-invalid': field.invalid,
             'ng-touched': field.touched
            }">
             <span class="select-value ellipsis">{{getValue()}}
                 <span *ngIf="!getValue()">{{placeholder}}</span>
                 <span class="down-icon">&#9662;</span>
             </span>
             <select #select [disabled]="disabled" [formControl]="field" [required]="required" (ngModelChange)="emitModel($event)" [(ngModel)]="model">
                 <option *ngIf="selectAllVisible" [ngValue]="'all'">All</option>
                 <option *ngFor="let o of data"  [ngValue]="objectKey(o, value)">{{objectKey(o, key, true)}}</option>
             </select>
             <div class="form-errors" *ngIf="!field.valid">
                 <div *ngIf="field.hasError('required')"></div>
                 <div *ngIf="field.hasError('mask')">Data format is not valid</div>
                 <div *ngIf="field.hasError('minlength')">Must be at least {{minlength}} characters long</div>
                 <div *ngIf="field.hasError('maxlength')">Must be not more than {{maxlength}} characters long</div>
                 <div *ngIf="field.hasError('email')">Please enter a valid email address.</div>
                 <div *ngIf="field.hasError('remote')">{{field.errors.remote}}</div>
                 <div *ngIf="field.hasError('confirm')">Your passwords do not match</div>
                 <div *ngIf="field.hasError('min')">Must be greater then {{min}}</div>
                 <div *ngIf="field.hasError('max')">Must be less then {{max}}</div>
             </div>
         </div>`,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormSelectFieldComponent),
            multi: true
        }
    ]
})
export class FormSelectFieldComponent implements ControlValueAccessor {
    @ViewChild('select') select: any;

    @Input() field;
    @Input() placeholder: string;
    @Input() required: any;
    @Input() disabled: any;
    @Input() key: string;
    @Input() data: any;
    @Input() model: any;
    @Input() value: string;
    @Input() combinedKeysAllowed: boolean = false;
    @Input() combinedKeys: string[] = [];
    @Input() selectAllVisible: boolean = false;

    @Output() modelChange = new EventEmitter<any>();

    objectKey(obj, value, isDisplayVal) {
        return isDisplayVal && this.combinedKeysAllowed
            ? this.combinedKeys.reduce((str, key) => `${str} ${obj[key] ? obj[key] : ''}`, '')
            : typeof obj[value] === 'undefined' ? obj : obj[value];
    }
    getValue() {
        if (this.select) {
            return this.select.nativeElement.selectedIndex !== -1
                ? this.select.nativeElement.options[
                    this.select.nativeElement.selectedIndex
                ].text
                : null;
        }
    }

    emitModel(item) {
        this.modelChange.emit(item);
        this.propagateChange(item);
    }

    writeValue(value: any) {
        if (value !== null && typeof value !== 'undefined') {
            this.model = value;
        }
    }
    propagateChange = (_: any) => { };

    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
}
